import styled from '@emotion/styled';
import { useCallback, useMemo } from 'react';
import { MoreMenu } from 'ui-components/common/MoreMenu';
import { RollingDispatchParams } from 'state-hooks/rolling/useRollingDispatch';
import { showAlertModal } from 'utils/modal';
import { RollingAction, RollingActionText } from '@diritto/common/rolling/constants';
import { Color } from '@diritto/common/style/color';
import { RollingRelayDto } from '@diritto/common/relay/dtos/rolling-relay.dtos';

interface RollingMoreMenuProps {
  rolling: RollingRelayDto;
  actions: RollingAction[];
  onDispatchAction: (params: RollingDispatchParams) => void;
}

export const RollingMoreMenu = ({ onDispatchAction, rolling, actions }: RollingMoreMenuProps) => {
  const handleAction = useCallback(
    async (action: RollingAction) => {
      switch (action) {
        case RollingAction.Share:
          onDispatchAction?.({ action, rolling });
          return;
        case RollingAction.GoToAdd: {
          onDispatchAction?.({ action });
          return;
        }
        case RollingAction.GoToEdit: {
          onDispatchAction?.({ action, rolling });
          return;
        }
        case RollingAction.Create: {
          return;
        }
        case RollingAction.Update: {
          return;
        }
        case RollingAction.Delete:
          showAlertModal(
            {
              title: '롤링을 삭제하시겠어요?',
              description: '삭제 시, 영구적으로 삭제되며 되돌릴 수 없어요.',
            },
            {
              cancelText: '취소',
              confirmText: '롤링 삭제',
              onConfirm: () => onDispatchAction?.({ action, rolling }),
            },
          );
          return;
        default:
          console.log("[RollingMoreMenu] Can't find action", action);
      }
    },
    [onDispatchAction, rolling],
  );

  const menu = useMemo(
    () =>
      actions.map(action => ({
        title: RollingActionText[action] || '',
        onClick: () => handleAction(action),
      })),
    [actions, handleAction],
  );

  return <StyledMoreMenu vertical menu={menu} color={Color.Gray500} />;
};

const StyledMoreMenu = styled(MoreMenu)`
  margin-left: auto;
`;
